// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h4.ant-typography {\n\tfont-size: 16px !important;\n}\n\n.O216J3zFziOYAHTxFCJY {\n\twidth: 500px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/management/estimator/PortPurposeSettings.module.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb","sourcesContent":["h4:global(.ant-typography) {\n\tfont-size: 16px !important;\n}\n\n.tableContainer {\n\twidth: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": "O216J3zFziOYAHTxFCJY"
};
export default ___CSS_LOADER_EXPORT___;
